import { render, staticRenderFns } from "./page_content_display.vue?vue&type=template&id=3a3a938c&"
import script from "./page_content_display.vue?vue&type=script&lang=js&"
export * from "./page_content_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3a938c')) {
      api.createRecord('3a3a938c', component.options)
    } else {
      api.reload('3a3a938c', component.options)
    }
    module.hot.accept("./page_content_display.vue?vue&type=template&id=3a3a938c&", function () {
      api.rerender('3a3a938c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/page-content/page_content_display.vue"
export default component.exports